import { Util } from '@grandvisionhq/forms'

export const isValidBirthDate = (value: string): boolean => {
  const [year, month, day] = value.split('-')

  if (!year || !month || !day) {
    return false
  }
  return Util.validations.isValidBirthDate(year, month, day)
}
